module.exports = __webpack_public_path__ + "static/media/1012826.e8287f84.png";